import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "colour"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import styled from 'styled-components';
import { pxToRem } from 'utils/ui/units';
import { alpha } from 'utils/ui/colors';
import Pill from '../../Pill';
import { jsx as _jsx } from "react/jsx-runtime";
var DotWrapper = styled.span.withConfig({
  displayName: "ScoreBandPill__DotWrapper",
  componentId: "sc-vf544g-0"
})(["display:flex;align-items:center;justify-content:center;width:", ";height:", ";"], pxToRem(24), pxToRem(24));
var Dot = styled.span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'colour';
  }
}).withConfig({
  displayName: "ScoreBandPill__Dot",
  componentId: "sc-vf544g-1"
})(["width:", ";height:", ";border-radius:100%;background-color:", ";box-shadow:0 0 0 1px ", ";"], pxToRem(10), pxToRem(10), function (p) {
  return p.colour;
}, function (p) {
  return alpha(p.theme.text, 0.2);
});
export default function ScoreBandPill(_ref) {
  var label = _ref.label,
    colour = _ref.colour,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Pill, _objectSpread(_objectSpread({}, otherProps), {}, {
    iconRenderer: function iconRenderer() {
      return /*#__PURE__*/_jsx(DotWrapper, {
        "aria-hidden": "true",
        children: /*#__PURE__*/_jsx(Dot, {
          colour: colour
        })
      });
    },
    children: label
  }));
}